import renderMaskedInput from 'components/FormControls/maskedInputField'
import renderInputField from 'components/FormControls/textInput'
import { Button } from 'gu-ui-kit'
import formStyles from 'modules/Forms/common-form.module.scss'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Field, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import phoneMask from 'utils/constants/phoneMask'
import phoneFieldNormalize from 'utils/normalize/phoneFieldNormalize'
import emailValidator from 'utils/validators/emailValidator'
import phoneValidator from 'utils/validators/phoneValidator'
import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  name: Yup.string().required('common::validation_messages.required'),
  email: Yup.string()
    .test(
      'emailValidator',
      'common::validation_messages.incorrect_email_format',
      emailValidator,
    )
    .required('common::validation_messages.required'),
  phone: Yup.string().test(
    'phoneValidator',
    'common::validation_messages.incorrect_phone_format',
    phoneValidator,
  ),
})

let CreateAgencyForm = ({ handleSubmit, submitting }) => {
  const { t } = useTranslation()
  const submit = useCallback(
    (values, dispatch) => dispatch({ type: 'AGENCY/CREATE', payload: values }),
    [],
  )

  return (
    <div className={formStyles['formContainer']}>
      <div className={formStyles['formContainer__inner']}>
        <h1 className={formStyles.formHeader}>
          {t('agency::create_agency_form.title')}
        </h1>
        <form onSubmit={handleSubmit(submit)} noValidate>
          <div className={'margin-bottom-16'}>
            <Field
              name="name"
              type="text"
              fullWidth
              component={renderInputField}
              label={t('agency::create_agency_form.controls.name')}
              t={t}
            />
          </div>

          <div className={'margin-bottom-16'}>
            <Field
              name="email"
              type="email"
              fullWidth
              component={renderInputField}
              label={t('agency::create_agency_form.controls.email')}
              t={t}
            />
          </div>

          <div className={'margin-bottom-16'}>
            <Field
              fullWidth
              normalize={phoneFieldNormalize}
              name="phone"
              component={renderMaskedInput}
              placeholderChar={'\u2002'}
              placeholder={'+ ( )'}
              mask={phoneMask}
              label={t('agency::create_agency_form.controls.phone')}
              t={t}
            />
          </div>

          <div className={formStyles['formControl__action-buttons']}>
            <div />
            <Button
              disabled={submitting}
              size="l"
              variant="primary"
              type="submit"
              bgColor={'Label-GU-Primary'}
            >
              {t('agency::create_agency_form.controls.submit')}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

CreateAgencyForm = reduxForm({
  form: 'CreateAgencyForm',
  initialValues: {
    name: '',
    email: '',
    phone: '',
  },
  asyncValidate: validator(validationSchema),
})(CreateAgencyForm)

CreateAgencyForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
}

CreateAgencyForm.defaultValues = {
  handleSubmit: () => {},
  submitting: false,
}

export default CreateAgencyForm
